import { BlacklistElementFragment } from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { useFormatTypedValue } from "src/hooks/useFormatTypedValue";
import { useT } from "src/internationalization";
import { mapToPropertyValue } from "src/mappers/property.mappers";
import { parseTypedValue } from "src/mappers/typedValue.mappers";
import { ClientSchemaBlacklist } from "src/types/clientSchema";
import { AppDataType } from "src/types/typedValue";
import { getValue } from "src/utils/string.utils.ts";

export type BlacklistElementRecord = Record<string, string> & { id: string };

export enum Origin {
  CASE_IDENTIFIER = "CASE_IDENTIFIER",
  MANUAL = "MANUAL",
  IMPORT = "IMPORT",
}

export const useListMetaData = (): { name: string; dataType: AppDataType; header?: string }[] => {
  const t = useT();

  return [
    { name: "id", dataType: "string" },
    {
      name: "adminStatus.lastModification",
      dataType: "date",
      header: t("page.blacklists.table.header.date.updated"),
    },
    //TODO To be removed when add disabled field
    {
      name: "status",
      dataType: "string",
      header: t("page.blacklists.table.header.status"),
    },
    {
      name: "origin",
      dataType: "string",
      header: t("page.blacklists.table.header.origin"),
    },
    {
      name: "sourceCaseType.name",
      dataType: "string",
      header: t("page.blacklists.table.header.caseType"),
    },
  ];
};

// TODO refactor this stuff
export const useMapListElementToRecord = () => {
  const listMetaData = useListMetaData();
  const formatTypedValue = useFormatTypedValue();
  return (
    item: BlacklistElementFragment,
    listSchema: ClientSchemaBlacklist
  ): BlacklistElementRecord => {
    const record = listSchema.properties.reduce(
      (acc, prop) => {
        const propertyValue = item.properties?.find((x) => x.property.code === prop.code);
        if (!propertyValue) return acc;
        const formatted = formatTypedValue(mapToPropertyValue(propertyValue).value);
        return { ...acc, [prop.name]: formatted };
      },
      { id: "" }
    );

    listMetaData.forEach((meta) => {
      record[meta.name] = formatTypedValue(
        parseTypedValue(getValue(item, meta.name), meta.dataType)
      );
    });

    record["status"] = !item.disabled;
    record["sourceProperties"] =
      item.blacklist?.identifier?.sourceProperties?.map((source) => source.code) || [];
    return record;
  };
};
